import type { JSX } from 'react';
import { isUndefined } from '@wistia/type-guards';
import { useTabsValue } from './useTabsValue';
import { useSelectedItemStyle } from '../SegmentedControl/useSelectedItemStyle';
import { TabsSelectedItemIndicatorDiv } from './TabsSelectedItemIndicatorDiv';

export const SelectedTabIndicator = (): JSX.Element | null => {
  const { selectedItemIndicatorStyle } = useSelectedItemStyle();
  const selectedValue = useTabsValue();

  if (selectedValue == null || isUndefined(selectedItemIndicatorStyle)) {
    return null;
  }

  return (
    <TabsSelectedItemIndicatorDiv
      data-wui-selected-item-indicator={true}
      style={selectedItemIndicatorStyle}
    />
  );
};
